import router from '@/router';

export function goToEditPharmacy(id: string): void {
  router.push({
    name: 'EditPharmacy',
    params: { id }
  });
}
